import {useContext} from "react";
import {authContext} from "../context/auth";
import {Navigate, useLocation} from "react-router-dom";
import Spinner from "./Spinner";

export default function ProtectedRoute({children}) {
    const {loading} = useContext(authContext);

    if (loading) {
        return <Spinner />;
    }

    return (
        children
    );
};
